import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import 'react-multi-email/style.css';
import SubmitButton from './../../components/SubmitButton/index';
import schema from './schema'
import { InfoMessage } from '../../components/Messages/index';

const InviteForm = ({
    inactiveMessage = '',
    onSubmit,
    readOnlyOptions = null,
    isUpdateMode,
    onInstructionsChange = () => null,
    additionalFieldsRenderer = () => null,
    warningMessage,
    sellerEmail=null
}) => {
    const defaultEmailValue = (readOnlyOptions || {}).receiver || '';
    const defaultInstructionsValue = (readOnlyOptions || {}).specialInstructions || '';

    const [email, setEmail] = useState(defaultEmailValue);    
    const [error, setError] = useState('');
    const [instructions, setInstructions] = useState(defaultInstructionsValue);

    const handleSubmit = async () => {
        if ( sellerEmail == email) {
            setError("Not allowed to enter buyer email same as of seller.")
            return;
        }
        schema.validate({ email }, { abortEarly: false })
            .then(() => {
                onSubmit({
                    email,
                    instructions
                })
            })
            .catch((err) => {
                const error = err.inner.reduce((acc, cur) => ({ ...acc, [cur.path]: cur.errors[0] }), {}).email
                setError(error)
            })
    }

    const getDisableError = () => {
        return inactiveMessage && inactiveMessage;
    }

    const handleInstructionsChange = (e) => {
        onInstructionsChange(e.target.value);
        setInstructions(e.target.value);
    }

    return (
        <div className='invite-form'>
            {!readOnlyOptions && <h4 className='page-subtitle'>Specify Buyer Email, Special Instructions and Address </h4>}

            <TextField
                margin="normal"
                id="name"
                label="Buyer's Email Address*"
                type="email"
                fullWidth
                variant="outlined"
                onChange={(e) => { setEmail(e.target.value); setError('') }}
                value={email}
                error={!!error}
                helperText={error}
                disabled={!!readOnlyOptions}
            />

            <TextField
                id="outlined-multiline-static"
                label="Seller's Special Instructions (e.g., See building behind parking lot)"
                margin="normal"
                variant="outlined"
                fullWidth
                value={instructions}
                onChange={handleInstructionsChange}
                multiline
                rowsMax="4"
                disabled={!!readOnlyOptions && !isUpdateMode}
            />

            {additionalFieldsRenderer()}

            {!readOnlyOptions && (
                <div className='form-controls'>
                    {warningMessage && <InfoMessage logger title={warningMessage} />}
                    <SubmitButton disableError={getDisableError() || warningMessage} title='Invite' onClick={handleSubmit} />
                </div>
            )}
        </div>
    );
}

export default InviteForm;